import { render, staticRenderFns } from "./DeleteOrganizationDialog.vue?vue&type=template&id=795fd6de&scoped=true&"
import script from "./DeleteOrganizationDialog.vue?vue&type=script&lang=js&"
export * from "./DeleteOrganizationDialog.vue?vue&type=script&lang=js&"
import style0 from "./DeleteOrganizationDialog.vue?vue&type=style&index=0&id=795fd6de&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "795fd6de",
  null
  
)

export default component.exports